import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractSettingsComponent } from '@app/pages';
import { AuthService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
    standalone: false,
    selector: 'app-compare-data-detail',
    templateUrl: './compare-data-detail.component.html',
    styleUrls: ['./compare-data-detail.component.scss'],
})
export class CompareDataDetailComponent extends AbstractSettingsComponent {
    constructor(
        auth: AuthService,
        router: Router,
        route: ActivatedRoute,
        public translateService: TranslateService
    ) {
        super(auth, router, route);
    }
}
